<template>
  <div>
    <HeaderNoAccess></HeaderNoAccess>
  </div>
</template>

<script>
// import { HTTP } from '@/plugins/backendAPI'
import { logout } from '../../../helpers/logoutHandler';
import HTTP from '../../../plugins/backendAPI';
import HeaderNoAccess from '../../../components/HeaderNoAccess.vue';


export default {
  beforeRouteLeave(to) {
    if (this.$store.getters.redirectRoute && to.fullPath !== this.$store.getters.redirectRoute && this.$store.getters.isauthorized) {
      this.$router.push({
        path: this.$store.getters.redirectRoute,
      });
    } else {
      this.$store.dispatch("setRedirectRoute", null)
    }
  },
  components: {
    HeaderNoAccess
  },
  data() {
    return {
      token: null,
      loading: false,
      linkAccounts: false,
    }
  },
  async created() {

  },
  async mounted() {
    this.$store.dispatch('setLoading', true);
    this.$store.dispatch('saveUserSSOAuthMethod', this.$route.query["auth-method"]);
    if (this.$route.query["redirect-to"] === "/link-accounts") {
      await this.$router.push({ name: "LinkAccounts", query: { "auth-method": this.$route.query["auth-method"], "entra-tenant-id": this.$route.query["entra-tenant-id"], "organization-id": this.$route.query["organization-id"], "email": this.$route.query["email"] } })
      return
    }
    await this.$store.dispatch("setRedirectRoute", this.$route.query["redirect-to"])
    this.token = this.$route.query["token"]
    HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + this.token
    await HTTP.get('/users/get/logged-in-user')
      .then(async (response) => {
        await this.$store.dispatch('saveAuthorization', {
          username: response.data.email,
          isauthorized: true,
          bearertoken: this.token,
          isadministrator: response.data.isAdministrator,
          issuperadministrator: response.data.isSuperAdministrator,
          hasWorkspaceAuthorization: response.data.hasWorkspaceAuthorization,
          userAuthProvider: response.data.authProvider
        });
        await this.$store.dispatch('setLoading', false);
        this.$router.push({ name: "SsoWelcome" })
      })
      .catch(async e => {
        this.$store.dispatch('showError', `Getting logged in user failed: ${e.response.data}`)
        this.$store.dispatch('setLoading', false);
        await logout()
      })
  },
}
</script>
